import { render, staticRenderFns } from "./SalesTaxDocuments.vue?vue&type=template&id=480346ae&scoped=true&"
import script from "./SalesTaxDocuments.vue?vue&type=script&lang=ts&"
export * from "./SalesTaxDocuments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480346ae",
  null
  
)

export default component.exports